import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { type PartialProduct } from '../../../../graphql';

/**
 * Hook that allows navigating to the correct edit customization page.
 */
export const useNavigateToCustomizationEditScreen = (props: Params) => {
  const { addressId = '', restaurantSlug = '', isDelivery = false } = props;

  const router = useRouter();

  const navigateToCustomizationEditScreen = useCallback(
    (params: NavigateToCustomizationEditParams) => {
      const { lineItemId, product } = params;
      const productSlug = product?.slug ?? '';

      if (isDelivery) {
        router.navigate({
          pathname: '/delivery/[addressId]/[productSlug]/edit/[lineItemId]',
          params: { addressId, productSlug, lineItemId },
        });
        return;
      }

      router.navigate({
        pathname: '/[restaurantSlug]/[productSlug]/edit/[lineItemId]',
        params: { restaurantSlug, productSlug, lineItemId },
      });
    },
    [addressId, isDelivery, restaurantSlug, router],
  );

  return { navigateToCustomizationEditScreen };
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Params = Readonly<{
  isDelivery?: boolean;
  addressId?: string;
  restaurantSlug?: string;
}>;

type NavigateToCustomizationEditParams = Readonly<{
  lineItemId: string;
  product: PartialProduct;
}>;
